<template>
  <div style="margin-bottom: 70px">
    <div class="topContent">
      <div class="basicInformation">
        <div class="line"></div>
        <div class="lineText">基本设置</div>
        <div class="infoBox">
          <div class="infoItem">
            <div class="infoName">用户名</div>
            <div class="infoValue">{{ userName }}</div>
          </div>
          <div class="infoItem">
            <div class="infoName">密码</div>
            <div class="infoValue infoPassword" @click="openChangePasswordBox">
              修改密码
            </div>
          </div>
          <div class="infoItem">
            <div class="infoName">我的角色</div>
            <div class="infoValue">{{ userRole }}</div>
          </div>
          <div class="infoItem">
            <div class="infoName">所属组织</div>
            <div class="infoValue">{{ organization }}</div>
          </div>
        </div>
      </div>
      <div class="contact">
        <div class="line"></div>
        <div class="lineText">联系方式</div>
        <div class="infoBox">
          <div class="infoItem">
            <div class="infoName">手机</div>
            <div class="infoValue contactValue">{{ phone }}</div>
            <div class="infoOperate" @click="openChangePhoneBox">编辑</div>
          </div>
          <div class="infoItem">
            <div class="infoName">邮箱</div>
            <div class="infoValue contactValue">{{ email }}</div>
            <div class="infoOperate" @click="openChangeEmailBox">编辑</div>
          </div>
          <div class="infoItem">
            <div class="infoName">版本</div>
            <div class="infoValue contactValue">230609.1713</div>
          </div>
        </div>
      </div>
    </div>

    <div class="middleContent">
      <div class="logHeader">
        <div
          class="lineText"
          style="
            position: relative;
            width: 100px;
            display: inline-block;
            top: 30px;
          "
        >
          系统日志
        </div>
        <div class="searchPanel">
          <span class="searchInputText">用户名</span>
          <el-input
            placeholder="请输入用户名"
            v-model="searchUserName"
          ></el-input>
          <span class="searchInputText">操作名称</span>
          <el-input
            placeholder="请输入操作名称"
            v-model="operateName"
          ></el-input>
          <span class="searchInputText">操作时间-开始时间</span>
          <el-date-picker
            v-model="startTime"
            value-format="timestamp"
            type="datetime"
            placeholder="选择日期时间"
            align="right"
            :picker-options="pickerOptions1"
          >
          </el-date-picker>
          <span class="searchInputText">操作时间-结束时间</span>
          <el-date-picker
            v-model="endTime"
            value-format="timestamp"
            type="datetime"
            placeholder="选择日期时间"
            align="right"
            :picker-options="pickerOptions2"
          >
          </el-date-picker>
          <el-button type="danger" @click="doSearch">查找</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 98.5%; float: left; marginLeft:0.75% ;marginTop: 70px; paddingBottom: 10px"
      >
        <el-table-column
          prop="userName"
          align="center"
          label="用户名"
          min-width="20%"
        >
        </el-table-column>

        <el-table-column
          prop="permissionName"
          align="center"
          label="操作名称"
          min-width="20%"
        >
        </el-table-column>

        <el-table-column prop="ip" align="center" label="登陆IP" min-width="20%">
        </el-table-column>

        <el-table-column
          prop="code"
          align="center"
          label="操作结果"
          :formatter="formatStatus"
          min-width="20%"
        >
        </el-table-column>

        <el-table-column
          prop="startTime"
          align="center"
          :formatter="formatTime"
          label="时间"
          min-width="20%"
        >
        </el-table-column>
      </el-table>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      title="修改密码"
      :visible.sync="changePasswordBoxVisible"
      :close-on-click-modal="false"
      @close="handleClose"
      width="500px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changePasswordForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="原密码" label-width="100px" prop="原密码">
                <el-input
                  v-model="oldPassword"
                  placeholder="请输入原密码"
                  show-password
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="新密码" label-width="100px" prop="新密码">
                <el-input
                  v-model="newPassword"
                  placeholder="请输入新密码"
                  show-password
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="再次确认新密码"
                label-width="100px"
                prop="确认新密码"
              >
                <el-input
                  v-model="twiceNewPassword"
                  placeholder="请再次输入新密码"
                  show-password
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="SubmitPasswordChange">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改手机号"
      :visible.sync="changePhoneBoxVisible"
      :close-on-click-modal="false"
      @close="closePhoneBox"
      width="500px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changePhoneForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="新手机号"
                label-width="100px"
                prop="新手机号"
              >
                <el-input
                  v-model="newPhone"
                  placeholder="请输入新手机号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePhoneBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="SubmitPhoneChange">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改邮箱"
      :visible.sync="changeEmailBoxVisible"
      :close-on-click-modal="false"
      @close="closeEmail"
      width="500px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeEmailForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="新邮箱地址"
                label-width="100px"
                prop="新邮箱地址"
              >
                <el-input
                  v-model="newEmail"
                  placeholder="请输入新邮箱地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeEmailBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="SubmitEmailChange">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
import {encryption} from "../../utils/commons"
import {
  findOneUserUsingGET,
  resetPassword,
  modUser,
  syslogSearch,
} from "../../utils/api";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      arrowList: [
        {
          name: "个人设置",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      userName: "加载中",
      userRole: "加载中",
      organization: "加载中",
      phone: "加载中",
      email: "加载中",
      address: "加载中",
      changePasswordBoxVisible: false,
      changePhoneBoxVisible: false,
      changeEmailBoxVisible: false,
      actionName: "",
      modelObj: {},
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 25,
      },
      maintaiSearch: "",
      tableData: [],
      searchUserName: "",
      operateName: "",
      startTime: "",
      endTime: "",
      oldPassword: "",
      newPassword: "",
      twiceNewPassword: "",
      newPhone: "",
      newEmail: "",
      pickerOptions1: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  computed: {
    rules: function () {
      return {
        careCont: [{ required: true, message: "必填" }],
        careTime: [{ required: true, message: "必填" }],
        principal: [{ required: true, message: "必填" }],
        principalPhone: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    let showType = this.$route.query.type || ''
    var userCode = window.localStorage.getItem("userCode");
    let params = {
      userCode: userCode,
    };
    findOneUserUsingGET(params).then((res) => {
      let content = res.data.content;
      if (content == undefined) {
        this.$notify.error({
          title: "错误",
          message: "用户信息获取失败"
        });
        this.userRole = "加载失败";
        this.userName = "加载失败";
        this.organization = "加载失败";
        this.phone = "加载失败";
        this.email = "加载失败";
        this.address = "加载失败";
        return;
      }
      this.userName = content.name;
      this.userRole = content.roleName;
      this.organization = content.officeName;
      this.phone = content.phone;
      this.email = content.email;
    });

    this.initLog();
    if(showType == 1){
      this.openChangePasswordBox()
    }
  },
  methods: {
    openChangePasswordBox() {
      this.changePasswordBoxVisible = true;
    },
    openChangePhoneBox() {
      this.changePhoneBoxVisible = true;
    },
    openChangeEmailBox() {
      this.changeEmailBoxVisible = true;
    },
    SubmitPasswordChange() {
      if (this.oldPassword == "" || this.oldPassword == undefined) {
        this.$notify({
          title: "警告",
          message: "原密码不能为空！",
          type: "warning",
        });
        return;
      }

      if (this.newPassword == "" || this.newPassword == undefined) {
        this.$notify({
          title: "警告",
          message: "新密码不能为空！",
          type: "warning",
        });
        return;
      }

      if (this.twiceNewPassword == "" || this.twiceNewPassword == undefined) {
        this.$notify({
          title: "警告",
          message: "确认新密码不能为空！",
          type: "warning",
        });
        return;
      }

      if (this.newPassword != this.twiceNewPassword) {
        this.$notify({
          title: "警告",
          message: "新密码的两次输入不一致！",
          type: "warning",
        });
        return;
      }
      let params = {
        oldPassword: encryption(this.oldPassword),
        password: encryption(this.newPassword),
        rePassword: encryption(this.twiceNewPassword)
      };
      resetPassword(params).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: res.data.content,
            type: "success",
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: res.data.message,
          });
        }
      });

      this.changePasswordBoxVisible = false;
    },
    SubmitPhoneChange() {
      if (this.newPhone == "" || this.newPhone == undefined) {
        this.$notify({
          title: "警告",
          message: "新手机号不能为空！",
          type: "warning",
        });
        return;
      }

      let userCode = window.localStorage.getItem("userCode");

      let params = {
        userCode: userCode,
        phone: this.newPhone,
      };

      modUser(params).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
          this.phone = params.phone;
        } else {
          this.$notify({
            title: "警告",
            message: res.data.message,
            type: "warning",
          });
        }
      });

      this.changePhoneBoxVisible = false;
    },
    SubmitEmailChange() {
      if (this.newEmail == "" || this.newEmail == undefined) {
        this.$notify({
          title: "警告",
          message: "新邮箱地址不能为空！",
          type: "warning",
        });
        return;
      }

      let userCode = window.localStorage.getItem("userCode");

      var params = {
        email: this.newEmail,
        userCode: userCode,
      };

      modUser(params).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
          this.email = params.email;
        }
      });
      this.changeEmailBoxVisible = false;
    },
    getLocalTime(nS) {
      return new Date(nS).toLocaleString().replace(/:\d{1,2}$/, " ");
    },
    doSearch() {
      this.pageMsg = {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      };
      this.initLog();
    },
    handleClose() {
      this.twiceNewPassword = "";
      this.oldPassword = "";
      this.newPassword = "";
    },
    closePasswordBox() {
      this.changePasswordBoxVisible = false;
    },
    closePhoneBox() {
      this.newPhone = "";
    },
    closeEmail() {
      this.newEmail = "";
    },
    initLog() {
      var params = {};
      params.userName = this.searchUserName;
      params.startTime = this.startTime;
      params.endTime = this.endTime;
      params.permissionName = this.operateName;
      params.pageNo = this.pageMsg.pageNo;
      params.pageSize = this.pageMsg.pageSize;
      syslogSearch(params).then((res) => {
        if (res.status != 200) {
          this.$notify.error({
            title: "失败",
            message: "日志数据获取失败",
          });
        }
        this.tableData = res.data.content.info.list;
        this.pageMsg.totalRecords = res.data.content.info.totalRecords;
      });
    },
    pageSizeChange(size) {
      this.pageMsg.pageSize = size;
      this.initLog();
    },
    currentPageChange(index) {
      this.pageMsg.pageNo = index;
      this.initLog();
    },
    formatStatus(row, column) {
      if (column.property == "code") {
        if (row.code == 200) {
          return "成功";
        } else {
          return "失败";
        }
      }
    },
    formatTime(row, column) {
      if (column.property == "startTime") {
        return this.getLocalTime(row.startTime);
      }
    },
  },
  components: {
    ElPageCover,
  },
};
</script>

<style lang="scss" scoped="">
.middleContent {
  width: 1890px;
  float: left;
  height: auto;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  margin-left: 10px;
  margin-top: 10px;
}

.topContent {
  width: 1890px;
  height: 263px;
  float: left;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  margin-left: 10px;
  .basicInformation {
    width: 945px;
    height: 263px;
    position: absolute;
    left: 0;
  }
  .contact {
    width: 945px;
    height: 263px;
    position: absolute;
    right: 0;
  }
}
.line {
  height: 16px;
  width: 4px;
  background-color: #fa0c28;
  position: absolute;
  top: 20px;
  left: 21px;
}
.lineText {
  height: 16px;
  line-height: 16px;
  font-size: 15px;
  color: #222222;
  position: absolute;
  top: 21px;
  left: 34px;
  font-weight: bold;
}

.infoBox {
  margin-top: 60px;
  margin-left: 105px;
  .infoItem {


    div {
      display: inline-block;
      height: 50px;
      line-height: 32px;
    }
    .infoName {
      color: #777777;
      font-size: 14px;
      width: 100px;
      text-align: left;
    }
    .infoValue {
      color: #282828;
      font-size: 15px;
    }
    .contactValue {
      width: 223px;
    }
    .infoOperate {
      color: #e96b5a;
      cursor: pointer;
    }
    .infoPassword {
      color: #e96b5a;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

.searchPanel {
  position: relative;
  bottom: 10px;
  left: 176px;
  padding-top: 10px;
  .el-input {
    width: 200px;
    height: 36px;
  }
  .searchInputText {
    display: inline-block;
    margin-right: 20px;
  }
  button {
    margin-left: 24px;
  }
}

.el-table__header tr th {
  background-color: #f2f2f5 !important;
  color: #555555 !important;
  font-size: 14px;
}

.logHeader {
  height: 10px;
}

.pageBlock {
  float: right;
  margin-bottom: 20px;
}
</style>